(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('bcn-store-config')?.textContent || '{}');
  let forms = [...document.querySelectorAll('[data-bcn-localization] form')];
  if (!forms.length) return;
  const allowed = new Set(['ES', 'MX', 'CO', 'AR', 'CL']);
  const available = new Set([...forms[0].querySelectorAll('option')].filter(o => !o.disabled && allowed.has(o.value)).map(o => o.value));
  const current = String(config.country || window.Shopify?.country || '').toUpperCase();
  const key = 'bcn-preferred-country-v2:' + (config.shop || window.location.host);
  const sessionKey = 'bcn-region-checked-v2:' + (config.shop || window.location.host);
  const maxAge = 90 * 24 * 60 * 60 * 1000;
  let manualChange = false;
  const read = (storage, name) => {try {return window[storage].getItem(name);} catch {return null;}};
  const write = (storage, name, value) => {try {window[storage].setItem(name, value);} catch { /* Localization still works without browser storage. */ }};
  const remember = country => write('localStorage', key, JSON.stringify({country, expires: Date.now() + maxAge}));
  const pageURL = new URL(window.location.href);
  const arrivedChoice = pageURL.searchParams.get('bcn_country_choice');
  const arrivedChecked = pageURL.searchParams.has('bcn_region_checked');
  if (available.has(arrivedChoice)) remember(arrivedChoice);
  if (arrivedChoice || arrivedChecked) {
    write('sessionStorage', sessionKey, '1');
    pageURL.searchParams.delete('bcn_country_choice');
    pageURL.searchParams.delete('bcn_region_checked');
    window.history.replaceState(window.history.state, '', pageURL.pathname + pageURL.search + pageURL.hash);
  }

  function submitCountry(country, manual, sourceForm = forms[0]) {
    if (!available.has(country)) return;
    if (manual) remember(country);
    forms.forEach(form => {form.querySelector('[data-bcn-country-select]').value = country;});
    if (country === current) return;
    write('sessionStorage', sessionKey, '1');
    // Carry the preference through Markets that use another domain, then remove it on arrival.
    const returnURL = new URL(window.location.href);
    returnURL.searchParams.set('bcn_region_checked', '1');
    if (manual) returnURL.searchParams.set('bcn_country_choice', country);
    let returnInput = sourceForm.querySelector('[name="return_to"]');
    if (!returnInput) {
      returnInput = document.createElement('input');
      returnInput.type = 'hidden';returnInput.name = 'return_to';sourceForm.append(returnInput);
    }
    returnInput.value = returnURL.pathname + returnURL.search + returnURL.hash;
    forms.forEach(form => {
      form.setAttribute('aria-busy', 'true');
      form.querySelector('[data-bcn-currency-status]').textContent = 'Actualizando moneda…';
    });
    // Keep the selected country in the POST; disabling the select would omit it.
    HTMLFormElement.prototype.submit.call(sourceForm);
  }

  function bindForms() {
    forms = [...document.querySelectorAll('[data-bcn-localization] form')];
    forms.forEach(form => {
      if (form.dataset.bcnReady) return;
      form.dataset.bcnReady = 'true';
      form.querySelector('[data-bcn-country-select]').addEventListener('change', e => {
        manualChange = true;
        submitCountry(e.target.value, true, form);
      });
    });
  }
  bindForms();
  document.addEventListener('shopify:section:load', bindForms);

  async function detectCountry() {
    // Never reload the theme editor while the merchant is editing a section.
    if (config.designMode || window.Shopify?.designMode) return;
    let preference;
    try {preference = JSON.parse(read('localStorage', key) || 'null');} catch { /* Ignore a malformed old preference. */ }
    if (preference?.expires > Date.now() && available.has(preference.country)) {
      if (!arrivedChecked) submitCountry(preference.country, true);
      return;
    }
    if (arrivedChecked || read('sessionStorage', sessionKey)) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 4000);
    let country = available.has(current) ? current : 'MX';
    try {
      const root = (config.root || '/').replace(/\/?$/, '/');
      const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {credentials: 'same-origin', signal: controller.signal, headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Localization unavailable');
      const data = await response.json();
      const detected = String(data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle || '').toUpperCase();
      if (detected) country = available.has(detected) ? detected : 'MX';
    } catch { /* Retain an available active market if regional detection is temporarily unavailable. */ }
    finally {window.clearTimeout(timeout);}
    if (manualChange) return;
    write('sessionStorage', sessionKey, '1');
    submitCountry(country, false);
  }
  detectCountry();
})();
